import Beaker from "lucide-react/icons/flask-conical";
import { Link } from "react-router-dom";
import React, { useEffect } from "react";

export const ToolsNav = ({ pages = [] }: { pages?: any[] }) => {
  return (
    <nav aria-label="Breadcrumb" className="flex">
      <ol role="list" className="flex items-center space-x-4">
        <li>
          <div>
            <a href="#" className="text-primary hover:text-secondary">
              <Beaker aria-hidden="true" className="h-5 w-5 flex-shrink-0" />
              <span className="sr-only">Home</span>
            </a>
          </div>
        </li>
        {pages.map((page) => (
          <li key={page.name}>
            <div className="flex items-center">
              <svg
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
                className="h-5 w-5 flex-shrink-0 text-gray-300"
              >
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>

              <Link
                to={page.href}
                aria-current={page.current ? "page" : undefined}
                className="ml-4 text-sm font-medium "
              >
                {page.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};
